import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCloud2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconCloud2"><Path d="M10 3.5C11.6683 3.5 13.1772 4.18198 14.2637 5.28027C14.4236 5.44198 14.657 5.52952 14.8975 5.5127C15.014 5.50455 15.1315 5.5 15.25 5.5C18.0114 5.5 20.25 7.73858 20.25 10.5C20.25 10.5231 20.263 10.5405 20.2773 10.5479C21.8927 11.3756 23 13.0579 23 15C23 17.7614 20.7614 20 18 20H7C3.68629 20 1 17.3137 1 14C1 11.8812 2.09875 10.0198 3.75488 8.95312C3.93247 8.83875 4.05676 8.65346 4.09375 8.44531C4.5925 5.63473 7.04586 3.5 10 3.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCloud2;
